var $ = require('jquery')

/**
 * Toggles the visibility of a target element based on the interaction with specified buttons.
 */
function setupToggleButton(toggleBtnSelector, closeBtnSelector, targetSelector) {
    const $toggleBtn = $(toggleBtnSelector);
    const $closeBtn = $(closeBtnSelector);
    const $target = $(targetSelector);

    $toggleBtn.removeClass('hidden');

    const toggleVisibility = () => {
        $target.toggleClass('hidden-on-mobile visible-on-mobile');
        if ($target.hasClass('visible-on-mobile')) {
            $('body').addClass('no-scroll');
        } else {
            $('body').removeClass('no-scroll');
        }
    };

    $toggleBtn.on('click', toggleVisibility);
    $closeBtn.on('click', toggleVisibility);
}

/**
 * Polls for the presence of an element in the DOM. Once found, executes a callback function.
 */
function waitForElement(selector, callback) {
    // Check if the element is already present in the DOM
    const element = document.querySelector(selector);
    if (element) {
        callback(element);
        return;
    }

    // If the element is not present, use MutationObserver to wait for its addition
    const observer = new MutationObserver((mutations, observerInstance) => {
        const element = document.querySelector(selector);
        if (element) {
            observerInstance.disconnect(); // Stop observing when the element is found
            callback(element);
        }
    });

    observer.observe(document.body, {
        childList: true,     // Observe direct child nodes
        subtree: true,       // Also, observe child nodes of descendants
    });
}

/**
 * Reposition event elements
 */

/* Main Stage Content */
function repositionMainStageActionsCard() {
    if ($('.main-stage .stream-presenter-container').length) {
        $('.video-chat-wrap').append($('.main-stage-actions-wrapper'));
    }
    // Move first likeable item to actions wrapper
    var $likeableItem = $('.agenda__item-likeable-item').eq(0);
    $likeableItem.prependTo('.main-stage-actions-wrapper');

    var $buttons = $('.main-stage-action-btn');
    var $container = $('<div>', {
        class: 'mobile-action-btn-container'
    });

    // Move all the buttons into container for mobile
    $buttons.first().before($container);
    $buttons.appendTo($container);
}

function appendMainStagePluginHeaders() {
    const $questionBlockTitle = $('#question-block-title');

    const questionBlockCloseBtnHtml = `
        <div class="question-block-close-btn">
            <i class="fas fa-times"></i>
        </div>
    `;

    $(".question-plugin__title-header")
        .append($questionBlockTitle)
        .append(questionBlockCloseBtnHtml);

    $("#survey-container").prepend($('#survey-block-title'));
}

function setMainStageMobile() {
    // Setup main stage mobile interactions
    waitForElement('.minimal-chat', function() {
        setupToggleButton('.main-stage-mobile-chat', '.minimal-chat-close-btn', '.minimal-chat');
        setupToggleButton('.main-stage-mobile-qa', '.question-block-close-btn', '.main-stage__question-plugin');
    });
}

/* Homescreen Content */
function wrapHomescreenButtons() {
    $sponsorButtons = $('#base-sponsor-buttons');
    if ($sponsorButtons.length) {
        $sponsorButtons
            .insertAfter('.hs-buttons-block__title')
            .html($('.hsb-cards-container'))
            .parent()
            .addClass('base-sponsor-block')
    }
}

function restructureAgendaCardContent() {
    $('.hsa-card').each(function() {
        var $agendaCard = $(this);
        
        // Create and prepend header div with its child elements
        $('<div>', { class: 'hsa-card__header' })
            .append($agendaCard.find('.hsa-card__date'))
            .append($agendaCard.find('.hsa-card__time'))
            .prependTo($agendaCard.find('.hsa-card__info'));

        // Move the homescreen-bookmark-toggle inside .hsa-card__info
        $agendaCard.find('.homescreen-bookmark-toggle').appendTo($agendaCard.find('.hsa-card__info'));
    });

    $('.main-stage-agenda__agenda-item').each(function() {
        var $agendaCard = $(this);
        
        // Create and append title wrapper
        var $titleDiv = $('<div>', { class: 'main-stage-agenda__title-wrapper' })
            .append($agendaCard.find('.main-stage-agenda__agenda-item-title'))
            .prependTo($agendaCard.find('.main-stage-agenda__title-section'));

        // Create and append info wrapper inside the title wrapper
        $('<div>', { class: 'main-stage-agenda__info-wrapper' })
            .append($agendaCard.find('.main-stage-agenda__date'))
            .append($agendaCard.find('.main-stage-agenda__time'))
            .append($agendaCard.find('.main-stage-agenda__locations'))
            .append($agendaCard.find('.main-stage-agenda__calendar'))
            .appendTo($titleDiv);
    });
}

function setCustomNavigation() {
    $('.navbar__list-item-dropdown').each(function() {
        var $dropdown = $(this);
        // Check if any child list item has the 'active' class
        if ($dropdown.find('.navbar__list-item.active').length > 0) {
            // Add 'active' class to the corresponding dropdown link
            $dropdown.find('.navbar__dropdown-submenu-link').addClass('active');
        }
    });
}

/* Forms */
function repositionFormNav() {
    $domainLogo = $('.baseEvent #domain_logo');
    $nav = $('.regForm .form-nav');
    if ($domainLogo.length) {
        $nav.appendTo($domainLogo)
    }
    $nav.fadeIn(100);
}

function setCustomFileUpload() {
  $('.form__input--file-upload').each(function() {
        // Wrap with custom label
        $(this).wrap('<label class="custom-file-upload" tabindex="0"></label>');
        $(this).after('<span>Choose File</span>');
        $(this).parent('.custom-file-upload').after('<div class="chosen-file-name"></div>');
        $(this).parent('.custom-file-upload').on('keydown', function (e) {
            if (e.key == 'Enter' || e.key == ' ') {
                e.preventDefault();
                $(this).trigger('click');
            }
        });
        
        // Hide the original file input
        $(this).css('display', 'none');        
    });

    $(".form__input--file-upload").change(function() {
        var fileName = $(this).val().split('\\').pop();
        $(this).parent().next(".chosen-file-name").text(fileName || "");
    });

    $('.form__input--file-upload').animate({opacity: 1}, 500);
}

/* Layout Functions */
function setMainStageContent() {
    setMainStageMobile()
    repositionMainStageActionsCard();
    appendMainStagePluginHeaders();
}

function setHomescreenContent() {
    wrapHomescreenButtons()
    setCustomNavigation()
}

function setAgendaContent() {
    restructureAgendaCardContent()
}

function setFormContent() {
    repositionFormNav()
    setCustomFileUpload()
}

function setEventContent() {
    setMainStageContent()
    setHomescreenContent()
    setAgendaContent()
    setFormContent()
}

/*** Initialization ***/
$(document).ready(function() {
    // Set up custom event layout
    setEventContent()
});


